import axios from 'axios';
import api from '@http/api';

const axiosInstance = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
});

interface IRequestData {
  data: {
    cep: string;
  };
}

interface IResponseVIACEP {
  cidade_id: number;
  cidade_nome: string;
  cep: string;
  uf: string;
  numeroLocalidade: number;
  localidade: string;
  logradouro: string;
  tipoLogradouro: string;
  nomeLogradouro: string;
  complemento: string;
  abreviatura: string;
  bairro: string;
  erro?: boolean;
}

interface IResponse {
  response?: IResponseVIACEP;
  error: boolean;
}


class ApiCEPCorreios {
  public async SearchCEP({ data }: IRequestData): Promise<IResponse> {
    return await api

      .post<IResponseVIACEP>('/api/ContatoOffline/FindEndereco', data)
      .then(response => {
        if (response.data.erro) {
          return {
            error: true,
          };
        }

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }
}

export default ApiCEPCorreios;
